// TODO: [ID][TOKEN] hapus token yang dikirim lewat url
import SESSIONS from '../constants/sessions'
import moment from 'moment'
import router from '../routes'
import YoutubeId from 'get-youtube-id'

export const getToken = () => {
  const token =
    localStorage.vuex !== undefined
      ? JSON.parse(localStorage.vuex).user.token
      : {}

  return token
}

export const rulesNumber = (event) => {
  const keyCode = event.keyCode ? event.keyCode : event.which
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    return event.preventDefault()
  }
}

export const formatNominalMoney = (event) => {
  let res = ''
  if (event >= 0) {
    res = 'Rp ' + event.toLocaleString('id-ID')
  } else {
    res = '-Rp ' + Math.abs(event).toLocaleString('id-ID')
  }

  if (res.length > 18 && screen.width <= 812) {
    res = res.substr(0, 17) + '...'
  }

  return res
}

export function noRound(num, decimalLength = 0) {
  const [int, dec = ''] = String(num).split('.')
  const decimal = decimalLength > 0 ? dec.substring(0, decimalLength) : dec // ambil x digit tanpa pembulatan

  const formattedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  // const formattedInt = Number(int).toLocaleString('en-US')

  const result = decimal ? `${formattedInt}.${decimal}` : formattedInt

  return result
}

export const formatPrice = ({ nominal, isUs = false, isUseSymbol = true }) => {
  nominal = Number(nominal)
  if (isNaN(nominal)) return ''

  nominal = noRound(nominal, !isUs ? 4 : 0)

  if (isUseSymbol) {
    nominal = isUs ? '$' + nominal : nominal
  }

  /** 👇 pindah simbol minus dari $-123 jadi -$123 */
  if (nominal.includes('-')) {
    nominal = '-' + nominal.replace('-', '')
  }

  return nominal
}

export const convertFromNow = (time) => {
  return `${moment(time).fromNow()}`
}

export const regexUrl = (content) => {
  // Replace <a ... href="...">...</a> with <div ... onclick="console.log('href_url')">...</div>
  return content.replace(
    /<a([^>]*?)href="([^"]+)"([^>]*)>(.*?)<\/a>/gi,
    (match, pre, href, post, inner) => {
      const onClick = `window.location.href = '${href}'`
      return `<div${pre}${post} style="color:#5387eb;cursor:pointer" onclick="${onClick}">${inner}</div>`
    }
  )
}

export const regexWaNumber = (string) => {
  return /^(^\+62|62|^08)(\d{2,4}-?){2}\d{2,4}$/g.test(string)
}

export const dynamicGoBack = (route) => {
  // for content have child
  if (route.query && route.query.parent) {
    router.push({
      name: route.name,
      params: {
        id: route.query.parent,
        title: route.query.title,
      },
    })
  } else if (route.query && route.query.backTo) {
    const getRoute = route.query.backTo.split('/')
    //  for analysis from chat

    router.push({
      name: getRoute[0],
      params: {
        [getRoute[1]]: getRoute[2],
      },
      query: {
        ...(route.query.step && { step: route.query.step }),
        ...(route.query.title && { title: route.query.title }),
        ...(route.query.stock && { stock: route.query.stock }),
        ...(route.query.tab && { tab: route.query.tab }),
      },
    })
  } else if (route.query && route.query.back) {
    router.go(-1)
  } else {
    const backlink = route.meta.backLink
    if (backlink?.length > 0) {
      router.push({ name: backlink, query: route.query })
    }
  }
}

export const formatWhatsappMessage = (payload, value) => {
  if (payload) {
    const formatName = payload.replace(/\[nama]/g, value)
    const formatSymbol = formatName.replace(/ & /g, ' %26 ')

    return formatSymbol
  }
}

export function formatDate(dateStr) {
  // Convert date string to a Date object
  const dateObj = new Date(dateStr)

  // Get the current date and time
  const currentDatetime = new Date()
  const currentDate = currentDatetime.toISOString().slice(0, 10) // Format: YYYY-MM-DD

  // Get the date and time from the input Date object
  const inputDate = dateObj.toISOString().slice(0, 10) // Format: YYYY-MM-DD
  const inputTime = dateObj.toLocaleTimeString('en-US', {
    timeZoneName: 'short',
    hour12: false,
  }) // Format: HH:MM

  // Check if the input date is today
  if (currentDate === inputDate) {
    return `${inputTime} WIB`
  } else {
    return (
      dateObj.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
      }) + ' WIB'
    )
  }
}

export function convertObjectToQueryString(obj) {
  const exclude = ['page', 'size']

  const keyValuePairs = Object.entries(obj)
    .filter(([key, value]) => value !== '' && !exclude.includes(key))
    .map(([key, value]) => `${key}:${value}`)

  const queryString = keyValuePairs.join(',')

  return queryString
}

export const objectToFormData = (payload) => {
  const formData = new FormData()

  for (let i = 0; i < Object.keys(payload).length; i++) {
    formData.append(Object.keys(payload)[i], Object.values(payload)[i])
  }

  return formData
}

export const ConvertToSlug = (payload) => {
  return payload
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
}

export const CapitalFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const CapitalFirstLetterSeparatedComma = (string) => {
  return string
    .split(',')
    .filter((item) => item?.length)
    .map((item) => CapitalFirstLetter(item.trim()))
    .join(', ')
}

export const CapitalFirstLetterSeparatedSpace = (string) => {
  return string
    .split(' ')
    .filter((item) => item?.length)
    .map((item) => CapitalFirstLetter(item.trim()))
    .join(' ')
}

export const StringToDate = (params) => new Date(params).toLocaleString('id-ID')

export const formatGetDay = (date) => {
  let result = moment(date).calendar().split(' at')[0].replace('Last ', '')

  if (result === 'Today') {
    return moment(date).format('HH:mm')
  }

  if (result !== 'Yesterday') {
    return moment(date).format('DD MMM YYYY')
  }

  return result
}

export const restrictPasswordInput = (event) => {
  const withEmojis = /\p{Extended_Pictographic}/u
  const isEmoji = withEmojis.test(event.key)
  const isWhitespace = event.charCode === 32

  if (isEmoji || isWhitespace) {
    // console.log('===> isEmoji', isEmoji)
    event.preventDefault()
    return false
  }

  return true
}

/**
 *
 * @param {*} countdown default 1 (one) because I don't want the result to be ZERO from the multiplication result
 * @param {*} expired is current valid expiration to get the current expired value already passed and time delay progress
 */
export const generateOtpExpiredData = (countdown, expired) => {
  // checking and set default value
  expired = Number(expired) || 0
  countdown = Number(countdown) || 1

  const normalCountdown = 60
  const valueOfOneSec = 1000
  const currentDate = new Date().valueOf()
  const valueOfTimeDelay = countdown * valueOfOneSec

  const newExpired = currentDate + valueOfTimeDelay
  const isValidExpiration = currentDate < expired
  const timeDelayProgress = (expired - currentDate) / valueOfOneSec
  const missedTimeDelayProgress =
    timeDelayProgress > 0 ? 0 : timeDelayProgress * -1
  const isToManyRequestOtp = countdown > normalCountdown

  const result = {
    countdown,
    timeDelayProgress: parseInt(timeDelayProgress),
    missedTimeDelayProgress: parseInt(missedTimeDelayProgress),
    expired,
    newExpired,
    isValidExpiration,
    currentDate,
    valueOfTimeDelay,
    isToManyRequestOtp,
  }

  return result
}

export const ConvertDate = (date) => {
  let newDate = date.slice(0, -6)
  let dateConvert = new Date(newDate + 'Z').toUTCString().slice(0, -7)
  let result = dateConvert + ' WIB'
  return result
}

export const ConvertDateV2 = (date) => {
  const result = new Date(date).toLocaleString('id-ID')
  return result
}

export const ConvertDateV3 = (date) => {
  const result = moment(date).format('DD MMMM YYYY')
  return result
}

export const getAllTimeStockPrice = (data) => {
  const price = data?.close || 0
  return {
    price,
    lowerPrice: !data?.low_all_time ? 1 : data?.low_all_time,
    heightPrice: data?.high_all_time || 1000000,
  }
}

export const getFileValidation = (file) => {
  if ([null, undefined].includes(file))
    return {
      fileSize: 0,
      isUpload: 0,
      isMaxSize: false,
      isShowPreview: false,
    }

  const maxFileSize = 2040000
  const fileSize = file[0]?.file?.size
  const isUpload = file[0]?.isUpload
  const isMaxSize = isUpload && fileSize > maxFileSize
  const isShowPreview = isUpload && fileSize <= maxFileSize

  return {
    fileSize,
    isUpload,
    isMaxSize,
    isShowPreview,
  }
}

export const FormatBase64 = (payload) => {
  return Buffer.from(JSON.stringify(payload)).toString('base64')
}

export const DecodeBase64 = (payload) => {
  return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'))
}

export const FormatList = (content) => {
  return content
    .replaceAll(': " ', ': ')
    .replaceAll(':="" ', ': ')
    .replaceAll(';="" ', '; ')
    .replaceAll(',="" ', ', ')
    .replaceAll('open="" sans"', 'open-sans')
    .replaceAll(';"=""', ';"')
    .replaceAll('font-variant: ', '')
    .replaceAll('" open-sans;', '')
}

export const FormatYoutubeVideo = (videoUrl) => {
  if (!videoUrl?.length) return ''

  const videoId = YoutubeId(videoUrl)
  const result = `https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&iv_load_policy=3&fs=1&disablekb=0&showinfo=0&autoplay=1&autohide=1&loop=1`
  return result
}

export const ElementIsVisibleInViewport = (el, partiallyVisible = false) => {
  if (el === null) return false

  const { top, left, bottom, right } = el.getBoundingClientRect()
  const { innerHeight, innerWidth } = window
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
}

export const GenerateBlogUrl = (pathUrl = '', token = '') => {
  // TODO: [ID][TOKEN] hapus token yang dikirim lewat url
  token = SESSIONS.IS_REFACTOR_STAGING ? token : ''
  const dataUrl = GetUrlData(process.env.VUE_APP_LANDING_PAGE_URL, pathUrl)
  return dataUrl
}

export const GenerateAcademyUrl = (pathUrl = '', token = '') => {
  // TODO: [ID][TOKEN] hapus token yang dikirim lewat url
  token = SESSIONS.IS_REFACTOR_STAGING ? token : ''
  const dataUrl = GetUrlData(process.env.VUE_APP_ACADEMY_URL, pathUrl)
  return dataUrl
}

const GetUrlData = (baseUrl, pathUrl = '') => {
  const isBase64 = CheckIsBase64(pathUrl)
  if (!isBase64) {
    pathUrl = pathUrl?.length ? pathUrl.replaceAll('//', '/') : '/'
  }

  const to = isBase64 ? pathUrl : FormatBase64(pathUrl)
  const fr = FormatBase64(window.location.href)
  // const tk = FormatBase64(token)

  // const targetUrl = `${baseUrl}client?to=${to}&tk=${tk}&fr=${fr}`
  const targetUrl = `${baseUrl}client?to=${to}&fr=${fr}`
  return targetUrl
}

export const CheckIsBase64 = (value) => {
  const regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
  const result = regex.test(value)
  return result
}

export const FormatMainContent = () => {
  const el = document.getElementById('main-content')
  const boxWidth = el?.offsetWidth

  // console.log('===> el', el)
  // console.log('===> boxWidth', boxWidth)

  if (typeof boxWidth !== 'number') {
    setTimeout(() => FormatMainContent(), 1000)
    return
  }

  /** 👇 format image */
  const images = document.querySelectorAll('#main-content img')
  images.forEach((imageEl) => {
    const imageWidth = imageEl?.offsetWidth
    const isImageLarger = imageWidth > boxWidth

    if (!isImageLarger) return

    imageEl.style = 'width: 100% !important; height: unset !important;'
  })

  /** 👇 format list */
  const listArr = document.querySelectorAll('#main-content ul > li > p')
  listArr.forEach((listEl) => {
    const listContent = FormatList(listEl.innerHTML)
    listEl.innerHTML = listContent
  })
}

export const GenerateQuery = (payload, text1, text2) => {
  let separator1 = text1?.length ? text1 : '='
  let separator2 = text2?.length ? text2 : '&'

  return Object.entries(payload)
    ?.filter((item) => (typeof item[1] === 'string' ? item[1].length : item[1]))
    ?.map((item) => item.join(separator1))
    ?.join(separator2)
}

export const ReplaceShopToAcademy = (url) => {
  const shopUrl = process.env.VUE_APP_OLD_ACADEMY_URL
  const academyUrl = process.env.VUE_APP_ACADEMY_URL

  if (!url?.length) return ''

  const result = url?.replace(shopUrl, academyUrl)
  return result
}

export const RedirectWithAnchor = (url = '', target = '_self') => {
  try {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.target = target
    anchor.click()
  } catch (error) {
    window.open(url, target)
    console.log('===> error', error)
  }
}
